(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../popup", "./Keyboard", "./KeyBoardOutputManager"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../popup"), require("./Keyboard"), require("./KeyBoardOutputManager"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.popup, global.Keyboard, global.KeyBoardOutputManager);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _popup, _Keyboard, _KeyBoardOutputManager) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _Keyboard = _interopRequireDefault(_Keyboard);
  _KeyBoardOutputManager = _interopRequireDefault(_KeyBoardOutputManager);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-number-keyboard"
      }, [_vm.isView ? [_c('keyboard', {
        attrs: {
          "hide-dot": _vm.hideDot,
          "show-num": _vm.showNum,
          "show-id": _vm.showId,
          "hide-close": _vm.hideClose,
          "board-type": _vm.boardType,
          "keyBoardIcon": _vm.keyBoardIcon
        },
        on: {
          "confirm": _vm.onConfirm,
          "output": function output($event) {
            return _vm.$emit('output', $event);
          },
          "delete": function _delete($event) {
            return _vm.$emit('delete');
          },
          "close": function close($event) {
            return _vm.$emit('close');
          }
        }
      })] : [_c('nx-popup', {
        ref: "popup",
        attrs: {
          "position": "sheets-bottom",
          "ariaAutoFocus": _vm.ariaAutoFocus,
          "lockScroll": false,
          "has-mask": false,
          "ariaPopupLabel": ""
        },
        on: {
          "show": function show($event) {
            return _vm.$emit('show');
          },
          "hide": function hide($event) {
            return _vm.$emit('hide');
          }
        },
        model: {
          value: _vm.isKeyboardShow,
          callback: function callback($$v) {
            _vm.isKeyboardShow = $$v;
          },
          expression: "isKeyboardShow"
        }
      }, [_c('keyboard', {
        attrs: {
          "hide-dot": _vm.hideDot,
          "show-num": _vm.showNum,
          "show-id": _vm.showId,
          "hide-close": _vm.hideClose,
          "board-type": _vm.boardType,
          "keyBoardIcon": _vm.keyBoardIcon
        },
        on: {
          "delete": function _delete($event) {
            return _vm.$emit('delete');
          },
          "confirm": _vm.onConfirm,
          "output": function output($event) {
            return _vm.$emit('output', $event);
          },
          "close": function close($event) {
            return _vm.$emit('close');
          }
        },
        nativeOn: {
          "touchmove": function touchmove($event) {
            $event.preventDefault();
          }
        }
      })], 1)]], 2);
    },
    name: 'nx-number-keyboard',
    KeyboardOutputManager: _KeyBoardOutputManager.default,
    components: (0, _defineProperty2.default)({
      Keyboard: _Keyboard.default
    }, _popup.default.name, _popup.default),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      hideDot: {
        type: Boolean,
        default: false
      },
      showNum: {
        type: Boolean,
        default: false
      },
      showId: {
        type: Boolean,
        default: false
      },
      isView: {
        type: Boolean,
        default: false
      },
      hideClose: {
        type: Boolean,
        default: false
      },
      boardType: {
        type: String,
        default: undefined
      },
      keyBoardIcon: {
        type: String
      },
      ariaAutoFocus: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        isKeyboardShow: false
      };
    },
    watch: {
      value: function value(val) {
        this.isKeyboardShow = val;
      },
      isKeyboardShow: function isKeyboardShow(val) {
        this.$emit('input', val);
      }
    },
    mounted: function mounted() {
      this.value && (this.isKeyboardShow = this.value);
    },
    methods: {
      show: function show() {
        this.isKeyboardShow = true;
      },
      hide: function hide() {
        this.isKeyboardShow = false;
      },
      onConfirm: function onConfirm() {
        this.$emit('confirm');
        this.hide();
      }
    }
  };
  _exports.default = _default;
});